import Head from 'expo-router/head';
import { Platform } from 'react-native';

import { IS_PRODUCTION } from '../../config/FruitfulEnvironment';
import { GOOGLE_TAG_MANAGER_ID } from './googleEventTracking';

/**
 * Loads the signup GTM container once on web production.
 * Mounted from the sign-up layout. Idempotent so a remount will not load gtm.js twice.
 */
export const GoogleTagManagerIntegration = () => {
    if (!IS_PRODUCTION || Platform.OS !== 'web') return null;

    return (
        <Head>
            <script>{`
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    if (d.querySelector('script[src*="googletagmanager.com/gtm.js?id='+i+'"]')) return;
    w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');
            `}</script>
        </Head>
    );
};
